// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.noScroll {
  position: fixed !important;
  overflow-y: hidden !important;
  width: 100%;
}

.widget-modal {
  position: absolute;
  top: 0;
  width: 100%;
  height: calc(100dvh - var(--header-height, 88px) - var(--toolbar-height, 48px));
  background-color: rgba(0, 20, 60, 0.8);
  z-index: 97;

  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;

  -webkit-overflow-scrolling: touch;
}

.widget-modal > iframe {
  border: 0;
  height: 100%;
  width: 100%;
  max-width: 500px;
  -webkit-overflow-scrolling: touch;
}

.isNative > .widget-modal {
  top: 0;
  height: 100dvh;
}

.isDesktop > .widget-modal,
.isTablet > .widget-modal {
  z-index: 11; /* 11 is the z-index of the betslip */
  top: var(--header-height, 80px); /* 80px is the height of the header */
  height: calc(100dvh - var(--header-height, 80px));
}

.isDesktop > .widget-modal iframe,
.isTablet > .widget-modal iframe {
  box-shadow: rgba(0, 20, 60, 0.25) 0 14px 28px 0, rgba(0, 20, 60, 0.22) 0 10px 10px 0;
}

.widget-modal__spinner {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);

  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 500px;

  background-color: #00215a;
}

.widget-modal__spinner:after {
  content: '';
  display: block;
  margin: auto;
  height: 64px;
  width: 64px;
  animation: spin 1.4s linear infinite;
  border: 5px solid #00afff;
  border-top-color: transparent;
  border-radius: 50%;
  align-self: center;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}`, "",{"version":3,"sources":["webpack://./src/css/main.css"],"names":[],"mappings":"AAAA;EACE,0BAA0B;EAC1B,6BAA6B;EAC7B,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,+EAA+E;EAC/E,sCAAsC;EACtC,WAAW;;EAEX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;;EAEhB,iCAAiC;AACnC;;AAEA;EACE,SAAS;EACT,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,MAAM;EACN,cAAc;AAChB;;AAEA;;EAEE,WAAW,EAAE,qCAAqC;EAClD,+BAA+B,EAAE,qCAAqC;EACtE,iDAAiD;AACnD;;AAEA;;EAEE,oFAAoF;AACtF;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,SAAS;EACT,2BAA2B;;EAE3B,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,gBAAgB;;EAEhB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,cAAc;EACd,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,oCAAoC;EACpC,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF","sourcesContent":[".noScroll {\n  position: fixed !important;\n  overflow-y: hidden !important;\n  width: 100%;\n}\n\n.widget-modal {\n  position: absolute;\n  top: 0;\n  width: 100%;\n  height: calc(100dvh - var(--header-height, 88px) - var(--toolbar-height, 48px));\n  background-color: rgba(0, 20, 60, 0.8);\n  z-index: 97;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n\n  -webkit-overflow-scrolling: touch;\n}\n\n.widget-modal > iframe {\n  border: 0;\n  height: 100%;\n  width: 100%;\n  max-width: 500px;\n  -webkit-overflow-scrolling: touch;\n}\n\n.isNative > .widget-modal {\n  top: 0;\n  height: 100dvh;\n}\n\n.isDesktop > .widget-modal,\n.isTablet > .widget-modal {\n  z-index: 11; /* 11 is the z-index of the betslip */\n  top: var(--header-height, 80px); /* 80px is the height of the header */\n  height: calc(100dvh - var(--header-height, 80px));\n}\n\n.isDesktop > .widget-modal iframe,\n.isTablet > .widget-modal iframe {\n  box-shadow: rgba(0, 20, 60, 0.25) 0 14px 28px 0, rgba(0, 20, 60, 0.22) 0 10px 10px 0;\n}\n\n.widget-modal__spinner {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 50%;\n  transform: translateX(-50%);\n\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  max-width: 500px;\n\n  background-color: #00215a;\n}\n\n.widget-modal__spinner:after {\n  content: '';\n  display: block;\n  margin: auto;\n  height: 64px;\n  width: 64px;\n  animation: spin 1.4s linear infinite;\n  border: 5px solid #00afff;\n  border-top-color: transparent;\n  border-radius: 50%;\n  align-self: center;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n\n  100% {\n    transform: rotate(360deg);\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
